import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { Link, useHistory } from 'react-router-dom';
import { Typography, Button } from '@material-ui/core';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { toJS } from 'mobx';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import { CustomTable, FilterPlaceholder } from '../../common/CustomTable';
import permissionCheck from '../../util/PermCheck';

const TransactionCategories = () => {
  const { dataStore } = useRootStore();
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const permitted = permissionCheck('TRANCAT_M');

  const accounts = dataStore.accountArray;

  const columns = () => [
    {
      Header: 'Code',
      accessor: 'Code',
      Filter: FilterPlaceholder,
    },
    {
      Header: 'Name',
      accessor: 'Name',
    },
    {
      Header: 'Income',
      accessor: 'ARContraAccountId',
      Cell: ({ row }) => {
        const act = dataStore.getAccountFromId(row.original.ARContraAccountId);
        return act ? act.AccountName : '';
      },
    },
    {
      Header: 'Expense',
      accessor: 'APContraAccountId',
      Cell: ({ row }) => {
        const act = dataStore.getAccountFromId(row.original.APContraAccountId);
        return act ? act.AccountName : '';
      },
    },
  ];

  const transactionCategories = dataStore.transactionCategoryArray;
  useEffect(() => {
    const initialize = async () => {
      if (transactionCategories.length === 0) {
        await dataStore.retrieveTransactionCategories();
      }
      if (accounts.length === 0) {
        await dataStore.retrieveAccounts();
      }
      setLoading(false);
    };
    initialize();
  }, []);
  if (isLoading) return <Spinner />;
  return (
    <Observer
      render={() => {
        return (
          <FlexDiv>
            <WideBox style={{ maxWidth: '1200px', width: '98%' }}>
              <CustomTable
                data={transactionCategories}
                columns={columns()}
                minRows={1}
                trClassName="react-table-hover-row"
                getTrProps={({ row }) => ({
                  onClick: () =>
                    permitted &&
                    history.push(
                      `/transaction-categories/${row.original.TranCategoryId}`,
                    ),
                })}
                tableHeader={
                  <Typography variant="h2"> Transaction Categories</Typography>
                }
                actionables={
                  permitted && (
                    <Button
                      variant="outlined"
                      color="primary"
                      component={Link}
                      to="/transaction-categories/new"
                    >
                      <CirclePlusIcon
                        style={{ marginRight: '4px', marginLeft: '-3px' }}
                      />
                      New Transaction Category
                    </Button>
                  )
                }
                containerStyle={{ padding: '0 2rem' }}
              />
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default TransactionCategories;
